import useDeviceId from 'lib/hooks/useDeviceId';
import httpService from 'lib/http/http.service';
import { useErrorHandler } from 'providers/ErrorHandler';
import { useOAuth } from 'providers/OAuthProvider';
import { useCallback, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import useHandleLocationSharing from './useHandleLocationSharing';
import { useDebounce } from './useDebounce';

export default function useInitializeHttpService() {
    const { axiosErrorHandler, handleError } = useErrorHandler();
    const { token: oAuthToken, isLoading: isOAuthLoading, login } = useOAuth();
    const navigate = useNavigate();
    const { requestDeviceId, deviceId } = useDeviceId({ onError: handleError });

    const ready = useMemo(
        () => !!oAuthToken && !!deviceId && !!axiosErrorHandler,
        [oAuthToken, deviceId, axiosErrorHandler]
    );

    const handleLocationSharingSuccess = useCallback(
        (lat: number, long: number) => {
            httpService.location = [lat, long];
            requestDeviceId();
            console.log('Location sharing successed');
        },
        [requestDeviceId]
    );

    const handleLocationSharingFailure = useCallback(() => {
        httpService.location = undefined;
        requestDeviceId();
    }, [navigate]);

    useDebounce(
        useHandleLocationSharing(
            handleLocationSharingSuccess,
            handleLocationSharingFailure
        )
    );

    useEffect(() => {
        httpService.errorHandler = axiosErrorHandler;
    }, [axiosErrorHandler]);

    useEffect(() => {
        if (deviceId) {
            httpService.deviceId = deviceId;
        }
    }, [deviceId]);

    useEffect(() => {
        if (isOAuthLoading) {
            return;
        }

        if (oAuthToken) {
            httpService.setAuthToken(oAuthToken);
        } else {
            login();
        }
    }, [oAuthToken, isOAuthLoading, login]);

    return ready;
}
